import React from 'react';
import JobProgressCard from '@/components/jobs/JobProgressCard';
import RecentJobsPanel from '@/components/jobs/RecentJobsPanel';

type Props = {
  jobsQueued: number;
  activeJobId: string | null;
  createdSubscriptionId: string | null;
  onSelectJob: (jobId: string) => void;
};

export default function WizardSuccessPanel({
  jobsQueued,
  activeJobId,
  createdSubscriptionId,
  onSelectJob,
}: Props) {
  return (
    <div className="wizard-success-panel" role="status">
      <div className="wizard-success-panel__icon" aria-hidden>
        ✓
      </div>
      <h2 className="wizard-success-panel__title">Alert created successfully</h2>
      <ul className="wizard-success-checklist">
        <li>Search created</li>
        <li>Subscription created</li>
        <li>Recipient linked</li>
        <li>
          {jobsQueued > 0
            ? `${jobsQueued} initial scrape job${jobsQueued === 1 ? '' : 's'} queued`
            : 'Scrape was not queued'}
        </li>
      </ul>
      {activeJobId && (
        <div className="wizard-success-panel__job">
          <JobProgressCard jobId={activeJobId} title="Setup scrape job" compact />
        </div>
      )}
      {createdSubscriptionId && (
        <RecentJobsPanel subscriptionId={createdSubscriptionId} onSelectJob={onSelectJob} />
      )}
    </div>
  );
}
